/* Lauren — Frequently Bought Together: total calc + multi add-to-cart */
(function () {
  const form = document.querySelector('[data-fbt-form]');
  if (!form) return;

  const checkboxes = form.querySelectorAll('input[data-fbt-price]');
  const totalEl = form.querySelector('[data-fbt-total]');
  const addBtn = form.querySelector('[data-fbt-add]');

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function recalc() {
    let total = 0;
    checkboxes.forEach((cb) => {
      if (cb.checked) total += parseInt(cb.dataset.fbtPrice, 10) || 0;
    });
    if (totalEl) totalEl.textContent = formatMoney(total);
  }

  checkboxes.forEach((cb) => cb.addEventListener('change', recalc));
  recalc();

  if (!addBtn) return;
  addBtn.addEventListener('click', async () => {
    const items = [];
    checkboxes.forEach((cb) => {
      if (cb.checked && !cb.disabled && cb.dataset.fbtId) {
        items.push({ id: parseInt(cb.dataset.fbtId, 10), quantity: 1 });
      }
    });
    if (items.length === 0) return;

    addBtn.disabled = true;
    const original = addBtn.textContent;
    addBtn.textContent = 'Adding...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error('Cart add failed');
      addBtn.textContent = 'Added ✓';
      // Trigger Dawn's cart drawer refresh
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        // Fallback: reload cart count
        const bubble = document.querySelector('#cart-icon-bubble');
        if (bubble) bubble.dispatchEvent(new CustomEvent('cart:update'));
      }
      setTimeout(() => {
        addBtn.disabled = false;
        addBtn.textContent = original;
      }, 1800);
    } catch (e) {
      console.error(e);
      addBtn.textContent = 'Try again';
      setTimeout(() => {
        addBtn.disabled = false;
        addBtn.textContent = original;
      }, 1800);
    }
  });
})();
